import { render } from "./DiscHero.vue?vue&type=template&id=db56db18"
import script from "./DiscHero.vue?vue&type=script&lang=js"
export * from "./DiscHero.vue?vue&type=script&lang=js"

import "./DiscHero.vue?vue&type=style&index=0&id=db56db18&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__